const column = (key, label, options = {}) => ({ key, label, minWidth: 130, ...options })
const filter = (key, label, options = {}) => ({ key, label, ...options })

const auditColumns = [
  column('sync_at', '供应商同步时间', { minWidth: 165 }),
  column('created_at', '创建时间', { minWidth: 165, detailOnly: true }),
  column('updated_at', '更新时间', { minWidth: 165, detailOnly: true }),
]

const rawColumn = column('raw_json', '供应商原始数据', { type: 'json', detailOnly: true })

export const YASITE_RESOURCE_DEFINITIONS = Object.freeze({
  hotel: {
    label: '酒店资源',
    description: '查看雅斯特酒店基础资料、营业与预订开放状态、托管属性及系统上架进度。',
    url: '/api/backend/yaSite/hotel/list',
    identity: 'hotel_code',
    filters: [
      filter('hotel_code', '酒店编码'),
      filter('chain_name', '酒店名称'),
      filter('city_id', '城市编号'),
      filter('area_id', '行政区编号'),
      filter('state', '营业状态', { type: 'hotelState' }),
      filter('book_flag', '可预订状态', { type: 'bookFlag' }),
      filter('is_up', '供应商启用状态', { type: 'enabled' }),
      filter('is_system_up', '系统上架状态', { type: 'systemUp' }),
    ],
    columns: [
      column('id', '数据编号', { width: 90, detailOnly: true }),
      column('hotel_code', '酒店编码', { minWidth: 145, fixed: 'left' }),
      column('chain_name', '酒店名称', { minWidth: 210 }),
      column('brand_name', '品牌名称', { minWidth: 150 }),
      column('external_chain_name', '外部酒店名称', { minWidth: 190, detailOnly: true }),
      column('chain_address', '酒店地址', { minWidth: 260 }),
      column('telephone', '联系电话', { minWidth: 145 }),
      column('post_code', '邮政编码', { detailOnly: true }),
      column('country', '国家或地区', { detailOnly: true }),
      column('city_id', '城市编号'),
      column('area_id', '行政区编号'),
      column('community_id', '商圈编号', { detailOnly: true }),
      column('region_id', '区域编号', { detailOnly: true }),
      column('sub_region_id', '子区域编号', { detailOnly: true }),
      column('three_region_id', '三级区域编号', { detailOnly: true }),
      column('longitude', '经度'),
      column('latitude', '纬度'),
      column('state', '营业状态', { type: 'hotelState' }),
      column('book_flag', '可预订状态', { type: 'bookFlag' }),
      column('is_up', '供应商启用状态', { type: 'enabled' }),
      column('is_have_room_status', '房态同步状态', { type: 'roomStatusReady' }),
      column('is_system_up', '系统上架状态', { type: 'systemUp' }),
      column('hotel_type', '门店预算类型', { type: 'hotelType', detailOnly: true }),
      column('chain_attribute', '门店经营属性', { type: 'chainAttribute', minWidth: 140 }),
      column('brand_type', '品牌类型', { type: 'brandType', detailOnly: true }),
      column('room_nums', '房间总数'),
      column('date_opened', '开业日期', { detailOnly: true }),
      column('review_avg_score', '平均评分'),
      column('reviews_count', '点评数量', { detailOnly: true }),
      column('is_new_hotel', '是否新酒店', { type: 'boolean', detailOnly: true }),
      column('includ_breakfast', '是否含早餐', { type: 'boolean', detailOnly: true }),
      column('includ_milk', '是否含牛奶', { type: 'boolean', detailOnly: true }),
      column('includ_fruits', '是否含水果', { type: 'boolean', detailOnly: true }),
      column('sort', '排序值', { detailOnly: true }),
      column('weight', '权重', { detailOnly: true }),
      column('tag', '酒店标签', { minWidth: 180, detailOnly: true }),
      column('remark', '备注', { minWidth: 220, detailOnly: true }),
      column('policy', '酒店政策', { type: 'longText', detailOnly: true }),
      column('summary', '酒店简介', { type: 'longText', detailOnly: true }),
      column('room_type_sync_at', '房型同步时间', { minWidth: 165 }),
      column('room_status_sync_at', '房态同步时间', { minWidth: 165 }),
      rawColumn,
      ...auditColumns,
    ],
  },
  area: {
    label: '行政区资源',
    description: '查看雅斯特省、市、区县及街道层级的行政区基础数据。',
    url: '/api/backend/yaSite/area/list',
    identity: 'area_key',
    filters: [filter('area_key', '行政区编号'), filter('parent_key', '上级行政区编号'), filter('level', '行政区层级', { type: 'areaLevel' }), filter('name', '行政区名称')],
    columns: [
      column('id', '数据编号', { width: 90, detailOnly: true }),
      column('area_key', '行政区编号', { minWidth: 145 }),
      column('parent_key', '上级行政区编号', { minWidth: 150 }),
      column('level', '行政区层级', { type: 'areaLevel' }),
      column('name', '行政区名称', { minWidth: 180 }),
      ...auditColumns,
    ],
  },
  room: {
    label: '房型资源',
    description: '查看酒店房型、房量、床位、最大入住人数及供应商有效状态。',
    url: '/api/backend/yaSite/room/list',
    identity: 'room_type_id',
    filters: [filter('hotel_code', '酒店编码'), filter('id', '系统编号'), filter('room_type_id', '房型编号'), filter('room_type_code', '房型编码'), filter('room_type_name', '房型名称'), filter('flag', '房型状态', { type: 'roomFlag' })],
    columns: [
      column('id', '系统编号', { width: 90 }),
      column('hotel_code', '酒店编码', { minWidth: 145, fixed: 'left' }),
      column('room_type_id', '房型编号'),
      column('room_type_code', '房型编码'),
      column('room_type_name', '房型名称', { minWidth: 190 }),
      column('room_count', '房间数量'),
      column('bed_count', '床位数量'),
      column('max_check_in_count', '最多入住人数', { minWidth: 140 }),
      column('flag', '房型状态', { type: 'roomFlag' }),
      column('sort', '排序值', { detailOnly: true }),
      column('description', '房型说明', { type: 'longText', minWidth: 240 }),
      column('remark', '备注', { type: 'longText', detailOnly: true }),
      rawColumn,
      ...auditColumns,
    ],
  },
  member: {
    label: '企业会员资源',
    description: '查看雅斯特 TMC 企业会员、渠道来源、可用房价类型及会员有效状态。',
    url: '/api/backend/yaSite/member/list',
    identity: 'meb_id',
    filters: [filter('hotel_code', '酒店编码'), filter('meb_id', '会员编号'), filter('meb_name', '会员名称'), filter('source_id', '来源编号'), filter('source_type', '来源类型'), filter('state', '会员状态', { type: 'memberState' }), filter('pay_type', '支付类型')],
    columns: [
      column('id', '数据编号', { width: 90, detailOnly: true }),
      column('hotel_code', '酒店编码', { minWidth: 145, fixed: 'left' }),
      column('meb_id', '企业会员编号'),
      column('meb_name', '企业会员名称', { minWidth: 190 }),
      column('card_no', '会员卡号', { minWidth: 145 }),
      column('source_id', '来源编号'),
      column('sub_source_id', '子来源编号', { detailOnly: true }),
      column('source_type', '来源类型代码'),
      column('sub_source_type', '子来源类型代码', { detailOnly: true }),
      column('room_rate_type_id', '默认房价类型编号', { minWidth: 160 }),
      column('room_rate_type_ids', '可用房价类型编号', { minWidth: 190 }),
      column('meb_type', '会员类型代码'),
      column('state', '会员状态', { type: 'memberState' }),
      column('pay_type', '支付类型'),
      column('address', '联系地址', { minWidth: 220, detailOnly: true }),
      column('contract_person', '联系人', { detailOnly: true }),
      column('contract_mobile', '联系电话', { detailOnly: true }),
      rawColumn,
      ...auditColumns,
    ],
  },
  rate: {
    label: '每日房价资源',
    description: '按入住日期查看门市价、协议价、首日价格及对应可售房量。',
    url: '/api/backend/yaSite/rate/list',
    identity: 'id',
    dateRange: true,
    filters: [filter('hotel_code', '酒店编码'), filter('meb_id', '会员编号'), filter('source_id', '来源编号'), filter('room_type_id', '房型编号'), filter('room_rate_type_id', '房价类型编号')],
    columns: [
      column('id', '数据编号', { width: 90, detailOnly: true }),
      column('hotel_code', '酒店编码', { minWidth: 145, fixed: 'left' }),
      column('acc_date', '入住日期', { minWidth: 120 }),
      column('room_type_id', '房型编号'),
      column('room_rate_type_id', '房价类型编号', { minWidth: 145 }),
      column('meb_id', '企业会员编号'),
      column('source_id', '来源编号'),
      column('sum_room_count', '总房量'),
      column('room_count', '可售房量'),
      column('max_check_in_count', '最多入住人数', { minWidth: 140 }),
      column('normal_rate', '门市价', { type: 'money' }),
      column('room_rate', '协议房价', { type: 'money' }),
      column('first_room_rate', '首间房价', { type: 'money' }),
      rawColumn,
      ...auditColumns,
    ],
  },
  status: {
    label: '每日房态资源',
    description: '按入住日期查看房型总房量和可售房量，快速识别无库存日期。',
    url: '/api/backend/yaSite/status/list',
    identity: 'id',
    dateRange: true,
    filters: [filter('hotel_code', '酒店编码'), filter('meb_id', '会员编号'), filter('source_id', '来源编号'), filter('room_type_id', '房型编号'), filter('room_type_name', '房型名称')],
    columns: [
      column('id', '数据编号', { width: 90, detailOnly: true }),
      column('hotel_code', '酒店编码', { minWidth: 145, fixed: 'left' }),
      column('acc_date', '入住日期', { minWidth: 120 }),
      column('room_type_id', '房型编号'),
      column('room_type_name', '房型名称', { minWidth: 190 }),
      column('meb_id', '企业会员编号'),
      column('source_id', '来源编号'),
      column('room_count', '总房量'),
      column('can_sale_count', '可售房量', { type: 'inventory' }),
      rawColumn,
      ...auditColumns,
    ],
  },
  image: {
    label: '图片资源',
    description: '预览酒店列表图、详情图和房型图，并追溯供应商原始数据。',
    url: '/api/backend/yaSite/image/list',
    identity: 'id',
    filters: [filter('hotel_code', '酒店编码'), filter('room_type_id', '房型编号'), filter('image_type', '图片类型')],
    columns: [
      column('id', '数据编号', { width: 90, detailOnly: true }),
      column('hotel_code', '酒店编码', { minWidth: 145, fixed: 'left' }),
      column('room_type_id', '房型编号'),
      column('image_type', '图片类型', { type: 'imageType' }),
      column('absolute_path', '图片预览', { type: 'image', minWidth: 180 }),
      rawColumn,
      ...auditColumns,
    ],
  },
  order: {
    label: '供应商订单',
    description: '集中查看系统订单与雅斯特订单关系、入住账务状态、支付状态及原始交互。',
    url: '/api/backend/yaSite/order/list',
    identity: 'order_no',
    dateRange: true,
    filters: [filter('api_account_id', 'API 账户编号'), filter('order_no', '系统订单号'), filter('folio_id', '雅斯特订单编号'), filter('hotel_code', '酒店编码'), filter('meb_id', '会员编号'), filter('source_id', '来源编号'), filter('acc_state', '账务状态', { type: 'accState' }), filter('pay_trans_state', '支付状态', { type: 'payTransState' })],
    columns: [
      column('id', '数据编号', { width: 90, detailOnly: true }),
      column('api_account_id', 'API 账户编号', { minWidth: 135 }),
      column('order_no', '系统订单号', { minWidth: 190, fixed: 'left' }),
      column('folio_id', '雅斯特订单编号', { minWidth: 150 }),
      column('hotel_code', '酒店编码', { minWidth: 145 }),
      column('source_id', '来源编号'),
      column('sub_source_id', '子来源编号', { detailOnly: true }),
      column('meb_id', '企业会员编号'),
      column('room_type_id', '房型编号'),
      column('room_rate_type_id', '房价类型编号', { minWidth: 145 }),
      column('arrival', '入住日期', { minWidth: 120 }),
      column('depart', '离店日期', { minWidth: 120 }),
      column('room_count', '预订房间数'),
      column('total_price', '订单总价', { type: 'money' }),
      column('folio_state', '订单状态', { type: 'folioState' }),
      column('acc_state', '账务状态', { type: 'accState' }),
      column('pay_trans_state', '支付状态', { type: 'payTransState' }),
      column('raw_request', '下单原始请求', { type: 'json', detailOnly: true }),
      column('raw_response', '下单原始响应', { type: 'json', detailOnly: true }),
      column('raw_status', '订单状态原始响应', { type: 'json', detailOnly: true }),
      column('created_at', '创建时间', { minWidth: 165 }),
      column('updated_at', '更新时间', { minWidth: 165 }),
    ],
  },
  log: {
    label: 'API 调用日志',
    description: '查看雅斯特接口调用结果、业务响应、HTTP 状态及完整请求响应报文。',
    url: '/api/backend/yaSite/api-log/list',
    identity: 'id',
    dateRange: true,
    filters: [filter('api_account_id', 'API 账户编号'), filter('source_api', '接口名称'), filter('code', '业务响应码'), filter('http_status', 'HTTP 状态码'), filter('message', '响应消息'), filter('error_message', '错误消息')],
    columns: [
      column('id', '日志编号', { minWidth: 100 }),
      column('api_account_id', 'API 账户编号', { minWidth: 135 }),
      column('source_api', '接口名称', { minWidth: 180 }),
      column('code', '业务响应码', { type: 'businessCode' }),
      column('message', '响应消息', { minWidth: 220 }),
      column('http_status', 'HTTP 状态码', { type: 'httpStatus' }),
      column('error_message', '错误消息', { minWidth: 260 }),
      column('request_json', '请求报文', { type: 'json', detailOnly: true }),
      column('response_json', '响应报文', { type: 'json', detailOnly: true }),
      column('created_at', '调用时间', { minWidth: 165 }),
    ],
  },
  statement: {
    label: '供应商对账单',
    description: '按 API 账户与离店日期范围查询雅斯特结算订单，核对供应商金额和订单状态。',
    url: '/api/backend/yaSite/reconciliation/orders',
    identity: 'system_order_no',
    statement: true,
    dateRange: true,
    filters: [filter('api_account_id', 'API 账户编号')],
    columns: [
      column('system_order_no', '系统订单号', { minWidth: 190, fixed: 'left' }),
      column('supplier_order_no', '雅斯特订单号', { minWidth: 170 }),
      column('hotel_code', '酒店编码', { minWidth: 145 }),
      column('hotel_name', '酒店名称', { minWidth: 200 }),
      column('departure_date', '离店日期', { minWidth: 120 }),
      column('total_rate', '供应商结算金额', { type: 'money', minWidth: 150 }),
      column('folio_state', '订单状态', { type: 'folioState' }),
      column('folio_ids', '关联雅斯特订单编号', { type: 'list', minWidth: 200 }),
    ],
  },
  worker: {
    label: '同步队列与运行状态',
    description: '监控 Go 消费进程、任务调度器、PHP 同步生产者和各时间分层队列积压情况。',
  },
})

const statusMaps = {
  hotelState: {
    1: ['筹建中', 'warning'],
    2: ['营业中', 'success'],
    3: ['已停业/解约', 'danger'],
    4: ['临时歇业', 'warning'],
  },
  bookFlag: { 0: ['不显示', 'info'], 1: ['可预订', 'success'], 2: ['显示满房', 'warning'] },
  enabled: { 1: ['已启用', 'success'], 0: ['已停用', 'info'] },
  roomStatusReady: { 1: ['已有房态', 'success'], 0: ['暂无房态', 'warning'] },
  systemUp: { 1: ['已上架', 'success'], 0: ['未上架', 'info'] },
  boolean: { true: ['是', 'success'], false: ['否', 'info'], 1: ['是', 'success'], 0: ['否', 'info'] },
  areaLevel: { 1: ['省级', ''], 2: ['市级', 'success'], 3: ['区县级', 'warning'], 4: ['街道级', 'info'] },
  roomFlag: { 0: ['已停用', 'info'], 1: ['有效', 'success'] },
  memberState: {
    1: ['登记未核对', 'warning'],
    2: ['有效', 'success'],
    3: ['作废', 'danger'],
    4: ['锁定', 'danger'],
  },
  folioState: {
    0: ['无意义', 'info'],
    1: ['已预订', 'success'],
    2: ['预订已取消', 'info'],
    3: ['预订未到', 'danger'],
    4: ['入住中', 'warning'],
    5: ['已退房', 'success'],
  },
  accState: { 0: ['全部/未明确', 'info'], 1: ['已开账', 'warning'], 2: ['已关账', 'success'] },
  payTransState: {
    0: ['未在线支付', 'info'],
    1: ['等待提交', 'warning'],
    2: ['等待结果', 'warning'],
    3: ['支付成功', 'success'],
    4: ['支付失败', 'danger'],
    5: ['支付取消', 'info'],
    6: ['已返还', 'success'],
    7: ['部分退款', 'warning'],
  },
  chainAttribute: {
    1: ['直营店', 'success'],
    2: ['加盟店', ''],
    3: ['特许经营', 'warning'],
    4: ['加盟合作店', 'warning'],
    5: ['加盟托管店', 'success'],
    6: ['委托管理', 'success'],
  },
  hotelType: { 11: ['有预算门店', 'success'], 12: ['无预算门店', 'warning'], 13: ['无数据门店', 'info'] },
  brandType: {
    1: ['雅斯特酒店', ''],
    3: ['雅美途酒店', 'success'],
    4: ['雅斯菲尔酒店', 'warning'],
    5: ['雅斯特国际', 'danger'],
    10: ['豪庭大酒店', 'warning'],
    22: ['宜致酒店', 'success'],
    83: ['温特莱酒店', 'info'],
    352: ['花居酒店', ''],
  },
  imageType: { 100: ['酒店列表图', 'success'], 101: ['酒店详情图', ''], 102: ['房型图', 'warning'] },
}

export function yaSiteTableColumns(definition) {
  return (definition && definition.columns ? definition.columns : []).filter(item => !item.detailOnly)
}

export function yaSiteStatusOptions(type) {
  const map = statusMaps[type]
  if (!map) return []
  return Object.keys(map).map(value => ({
    value: Number.isNaN(Number(value)) ? value : Number(value),
    label: map[value][0],
  }))
}

export function yaSiteStatusTag(column, value) {
  const type = column && column.type
  if (value === null || value === undefined || value === '') return null
  if (type === 'httpStatus') {
    const status = Number(value)
    if (status >= 200 && status < 300) return { label: `${value} 成功`, type: 'success' }
    if (status >= 400 && status < 500) return { label: `${value} 客户端错误`, type: 'warning' }
    if (status >= 500) return { label: `${value} 服务错误`, type: 'danger' }
    return { label: `HTTP ${value}`, type: 'info' }
  }
  if (type === 'businessCode') {
    const success = String(value) === '200'
    return { label: success ? `${value} 成功` : `${value} 异常`, type: success ? 'success' : 'danger' }
  }
  const map = statusMaps[type]
  if (!map) return null
  const item = map[value]
  return item
    ? { label: item[0], type: item[1] }
    : { label: `未知状态（${value}）`, type: 'info' }
}

export function yaSiteDisplayValue(value, column = {}) {
  if (value === null || value === undefined || value === '') return '-'
  const tag = yaSiteStatusTag(column, value)
  if (tag) return tag.label
  if (column.type === 'money') return `¥${String(value)}`
  if (column.type === 'list') return Array.isArray(value) ? value.join('、') : String(value)
  if (column.type === 'json' || column.type === 'longText') return '点击详情查看'
  if (typeof value === 'object') return Array.isArray(value) ? value.join('、') : '点击详情查看'
  return String(value)
}

export function yaSitePrettyValue(value) {
  if (value === null || value === undefined || value === '') return '-'
  if (typeof value === 'object') return JSON.stringify(value, null, 2)
  const text = String(value)
  const trimmed = text.trim()
  if ((trimmed.startsWith('{') && trimmed.endsWith('}')) || (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
    try { return JSON.stringify(JSON.parse(trimmed), null, 2) } catch (error) { return text }
  }
  return text
}

export function yaSiteAllFieldsCovered(definition, row) {
  const known = new Set((definition && definition.columns ? definition.columns : []).map(item => item.key))
  return Object.keys(row || {}).filter(key => !known.has(key))
}
